import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import {message} from "antd";
import {AUTH_TOKEN} from "../../constants/AuthConstant";
import lemburService from "../../services/lemburService";
import Cookies from "js-cookie";

export const initialState = {
    loading_lembur: false,
    loading_rekap_lembur: false,
    data_lembur: [],
    data_import: [],
    data_rekap_lembur: [],
    showMessage:false,
    message:'',
}


export const getDataLembur = createAsyncThunk('lembur/data',async (data, { rejectWithValue }) => {
    try {
        const response = await lemburService.data(Cookies.get(AUTH_TOKEN),data)
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})

export const getDataRekapLembur = createAsyncThunk('lembur/rekap',async (data, { rejectWithValue }) => {
    try {
        const response = await lemburService.show(Cookies.get(AUTH_TOKEN),data)
        return response
    } catch (err) {
        //message.error(err.response?.data?.message || 'Error',3)
    }
})

export const getaDataImport = createAsyncThunk('lembur/dataimport',async (data, { rejectWithValue }) => {
    try {
        const response = await lemburService.data_import(localStorage.getItem(AUTH_TOKEN))
        return response
    } catch (err) {
    }
})

export const emptyDataImport = createAsyncThunk('lembur/emptyimport',async (data, { rejectWithValue }) => {
    try {
        const response = await lemburService.empty_import(localStorage.getItem(AUTH_TOKEN))
        return response
    } catch (err) {
    }
})

export const saveDataImport = createAsyncThunk('lembur/saveimport',async (data, { rejectWithValue }) => {
    try {
        const response = await lemburService.save_import(localStorage.getItem(AUTH_TOKEN))
        return response
    } catch (err) {
    }
})

export const lemburSlice = createSlice({
    name: 'lembur',
    initialState,
    reducers: {
        showLoading: (state) => {
            state.loading_lembur = true
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getDataLembur.fulfilled, (state, action) => {
                state.loading_lembur = false
                state.data_lembur = action.payload??[]
            })
            .addCase(getDataLembur.pending, (state) => {
                state.loading_lembur = true
            })
            .addCase(getDataLembur.rejected, (state, action) => {
                state.loading_lembur = false
                state.data_lembur = action.payload
            })
            .addCase(getDataRekapLembur.fulfilled, (state, action) => {
                state.loading_rekap_lembur = false
                state.data_rekap_lembur = action.payload??[]
            })
            .addCase(getDataRekapLembur.pending, (state) => {
                state.loading_rekap_lembur = true
            })
            .addCase(getDataRekapLembur.rejected, (state, action) => {
                state.loading_rekap_lembur = false
                state.data_rekap_lembur = action.payload
            })
            .addCase(getaDataImport.fulfilled, (state, action) => {
                state.loading_lembur = false
                state.data_import = action.payload??[]
            })
            .addCase(getaDataImport.pending, (state) => {
                state.loading_lembur = true
            })
            .addCase(getaDataImport.rejected, (state, action) => {
                state.loading_lembur = false
                state.data_import = action.payload
            })
    },
})

export const {
    showLoading,
} = lemburSlice.actions

export default lemburSlice.reducer
